<template>
  <div class="view">
    <v-card width="300">
      <div
        class="header navy darken-2 secondary--text pb-10 d-flex flex-column align-center"
      >
        <img
          @dblclick="gotoLoginDeveloper"
          class="logo"
          :src="firebase_host + '/static/img/logo.png'"
        />
      </div>
      <!-- Sei non sei loggato -->
      <div v-if="!user_uid">
        <!-- Login per l'utente esiste solo in standalone-->
        <div
          v-if="Config.STANDALONE"
          class="px-8 py-5 d-flex flex-column align-center"
        >
          <h2 class="mb-5">Accedi a ASTA LIVE</h2>
          <div class="overlay-parent">
            <LoginSdkJs v-if="sdk == 'js-sdk'"></LoginSdkJs>
            <LoginSdkFb v-else-if="sdk == 'firebase-sdk'"></LoginSdkFb>
            <LoginSdkAndroid v-else-if="sdk == 'android-sdk'"></LoginSdkAndroid>
            <!-- <LoginSdkApple v-else-if="sdk == 'apple-sdk'"></LoginSdkApple> -->
            <div
              class="overlay-child"
              v-if="!isTcChecked"
              @click="showTcAlert"
            ></div>
          </div>
          <div class="d-flex align-center">
            <v-checkbox v-model="isTcChecked" label="Accetto"></v-checkbox>
            <a
              class="ml-1"
              target="_blank"
              :href="Config.TERMINI_E_CONDIZIONI_LINK"
            >
              Termini & Condizioni
            </a>
          </div>
        </div>

        <!-- su fantapazz: rigenera sessione a partire da firebase.token -->
        <div v-else class="px-8 py-5 d-flex flex-column align-center">
          <h2 class="mb-5">Non sei loggato</h2>
          <p>
            Aggiorna la pagina (o esci e rientra) per rigenerare la sessione
          </p>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import authentication from "../../js/auth";
import Config from "../../../config-app/config";

import LoginSdkJs from "./LoginSdkJs";
import LoginSdkFb from "./LoginSdkFb";
import LoginSdkAndroid from "./LoginSdkAndroid";
// import LoginSdkApple from "./LoginSdkApple";

// import { getAuth } from "firebase/auth";

// const auth = getAuth();

export default {
  name: "login-router",
  mixins: [mixins, toast],
  components: {
    LoginSdkJs,
    LoginSdkFb,
    LoginSdkAndroid,
    // LoginSdkApple
  },
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
      isTcChecked: false,
      displayName: authentication.getDisplayName(),
    };
  },

  methods: {
    gotoLoginDeveloper() {
      if (Config.LOGIN_DEVELOPER) {
        this.$router.push({
          path: "/login-developer",
          query: {
            redirect: this.$route.query.redirect,
          },
        });
      }
    },

    showTcAlert() {
      this.errorToast(
        "Attenzione",
        "Devi prima accettare Termini & Condizioni"
      );
    },

    checkTc() {
      if (!this.isTcChecked) {
        this.showTcAlert();
        return false;
      }
      return true;
    },
  },

  computed: {
    sdk() {
      const userAgent = navigator.userAgent.toLowerCase();
      const os = window.os;
      console.log('os', os)
      if (os == "android") {
        return "android-sdk";
      }

      if (os == "apple") {
        return "apple-sdk";
      }
      if (
        /iPhone|iPad|iPod/i.test(userAgent) ||
        /^((?!chrome|android).)*safari/i.test(userAgent)
      ) {
        return "js-sdk";
      } else {
        return "firebase-sdk";
      }
    },
  },

  mounted() {
    console.log("LoginRouter mounted.");
    if (this.user_uid) {
      this.successToast("Utente già loggato", this.displayName);
    }
  },

  created() {},

  destroyed() {
    console.log("LoginRouter destroyed.");
  },
};
</script>

<style lang="scss" scoped>
.view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100%;

  .header {
    position: relative;
    overflow: hidden;

    &:after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 115%;
      height: 35px;
      background-color: white;
      transform: skewY(-6deg);
    }
  }

  .logo {
    width: 102px;
    margin-top: 30px;
  }

  .overlay-parent {
    position: relative;

    .overlay-child {
      position: absolute;
      top: -10px;
      left: -10px;
      bottom: -20px;
      right: -20px;
    }
  }
}
</style>

